import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";

const SESSION_KEY = "posAuthenticatorOk";

function call(name, data) {
  return httpsCallable(functions, name)(data);
}

function message(error) {
  return (error && error.message) || "Could not finish this step.";
}

export function authenticatorSessionOk(uid) {
  return Boolean(uid) && sessionStorage.getItem(SESSION_KEY) === uid;
}

export function markAuthenticatorSession(uid) {
  if (uid) sessionStorage.setItem(SESSION_KEY, uid);
}

export function clearAuthenticatorSession() {
  sessionStorage.removeItem(SESSION_KEY);
}

export async function posAuthenticatorStatus() {
  const result = await call("posAuthenticatorStatus");
  return {
    enabled: result.data?.enabled === true,
    saved: result.data?.saved === true,
    setUpAt: typeof result.data?.setUpAt === "number" ? result.data.setUpAt : null,
  };
}

export async function setupPosAuthenticator() {
  const result = await call("setupPosAuthenticator");
  return result.data;
}

export async function verifyPosAuthenticator(token) {
  await call("verifyPosAuthenticator", { token });
}

export async function disablePosAuthenticator() {
  await call("disablePosAuthenticator");
}

export async function enablePosAuthenticator() {
  await call("enablePosAuthenticator");
}

export async function showPosAuthenticatorQr() {
  const result = await call("showPosAuthenticatorQr");
  return result.data?.qrCodeDataUrl || "";
}

export async function confirmPosAuthenticatorSignIn(token) {
  await call("confirmPosAuthenticatorSignIn", { token });
}

export function authenticatorError(error) {
  return message(error);
}
